<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/newlocations/atlanta/banner.jpg" class="w100" />
    </div>

    <div class="cust-content">
      <div class="head-info" v-if="$i18n.locale === 'en'">
        <div class="head-title">
          SCAD Atlanta — creative capital at the heart of the industry
        </div>
        <div class="head-desc">
          Train beside Fortune 500s, global studios, and luxury brands. LED
          volume stage, museum-level venues, digital media labs — all inside a
          modern urban campus.
        </div>
        <div class="head-tags">
          <span class="head-tag"
            >99% employed or in grad school (within 10 months)</span
          >
          <span class="head-tag">SCADpro industry projects</span>
          <span class="head-tag">Alumni in 100+ countries</span>
        </div>
      </div>

      <div class="head-info" v-if="$i18n.locale === 'zh'">
        <div class="head-title">SCAD 亚特兰大 — 创意之都，产业核心</div>
        <div class="head-desc">
          与财富 500 强公司、全球知名工作室及奢侈品牌比邻而立。 <br />LED
          虚拟影棚、博物馆级场馆、数字媒体实验室——尽在现代化都市校园之中。
        </div>
        <div class="head-tags">
          <span class="head-tag"
            >99%的毕业生在毕业12个月内实现就业或继续深造</span
          >
          <span class="head-tag">SCADpro 企业实战</span>
          <span class="head-tag">全球校友遍布 100+ 个国家</span>
        </div>
      </div>
      <div class="locationMenu">
        <div class="grid-content">
          <div class="locationMenuList">
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Atlanta' ? 'active' : ''"
              @click="locationMenuItemClick('Atlanta')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_01.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">A</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Atlanta</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  亚特兰大
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Lacoste' ? 'active' : ''"
              @click="locationMenuItemClick('Lacoste')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_02.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">L</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Lacoste</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  拉科斯特
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Savannah' ? 'active' : ''"
              @click="locationMenuItemClick('Savannah')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_03.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">S</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">
                  Savannah
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">萨凡纳</div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'SCADnow' ? 'active' : ''"
              @click="locationMenuItemClick('SCADnow')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_04.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">e</div>
                </div>
                <div class="nav-name">SCADnow</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video-box">
      <video
        src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20251103/HZ_2025-26_SCN_SCAD_Atlanta.01_final.mp4"
        controls
        poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20251103/HZ_2025-26_SCN_SCAD_Atlanta.01_final.mp4?x-oss-process=video/snapshot,t_21300"
      ></video>
    </div>

    <div class="cust-content">
      <div v-if="$i18n.locale === 'en'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <div class="content-title">Why Atlanta</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>Creative capital, real proximity</b>. Study in one of the
                    U.S.’s fastest-growing hubs for film, luxury, tech, and
                    design — where campus and industry are neighbors.
                  </li>

                  <li>
                    <b>On-set and on-brand</b>. From LED stage work to brand
                    collabs at
                    <a href="https://www.scadfash.org/" target="_blank"
                      >SCAD FASH</a
                    >, your coursework ties directly to Atlanta’s production,
                    fashion, and media ecosystem.
                  </li>
                  <li>
                    <b>Network in the city</b>. Major companies and studios
                    nearby turn projects into internships — and internships into
                    jobs.
                  </li>
                </ul>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >Explore facilities and programs</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/atlanta/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="building-box">
            <div
              class="building-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? buildingCnBanners
                    : buildingEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">Career pathways</div>
              <div class="text" style="margin-top: 30px">
                Through
                <a
                  href="https://www.scad.edu/about/industry-partnerships/scadpro"
                  target="_blank"
                  >SCADpro</a
                >, students solve real briefs with companies like Google, BMW,
                Nike, and Deloitte — building portfolios and networks.
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >Animation</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >Illustration</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >Interative design and game development</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >Fashion</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >Visual effects</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <div
                class="career-banner-swiper-container swiper-container location-banner"
              >
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(banner, index) in careerCnBanners"
                    :key="index"
                  >
                    <div class="slide-inner">
                      <img :src="banner.src" alt="" />
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination"></div>
                <img
                  class="button-prev"
                  src="@/assets/images/newlocations/img_01.png"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 30px;
                    z-index: 999999;
                  "
                />

                <img
                  class="button-next"
                  src="@/assets/images/newlocations/img_02.png"
                  style="
                    position: absolute;
                    top: 50%;
                    right: 30px;
                    z-index: 999999;
                  "
                />
              </div>
            </el-col>
          </el-row>

          <el-row class="climate-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/atlanta/07climate/01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="12" class="climate-content">
              <div class="content-title">Climate and transporation access</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>Climate</b>: Humid subtropical, similar to Shanghai or
                    Hangzhou, humid subtropical; four seasons, short mild
                    winter, warm spring
                  </li>

                  <li>
                    <b>Global access</b>: Hartsfield-Jackson Atlanta
                    International Airport (ATL), the world’s busiest, offers
                    easy direct and connecting flights.
                  </li>
                  <li>
                    <b>Metro convenience</b>: Quick access to studios, brand
                    hubs, and creative venues from campus.
                  </li>
                </ul>

                <div class="tips2">
                  <b>Note</b>: Can’t visit in person? Schedule a 10-minute
                  virtual tour or 1:1 meeting with SCAD Admission advisor.
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">Life and community</div>
            <div class="text">
              <b>Modern, safe, connected</b>. Live in
              <b>FORTY, FORTY FOUR, FORTY FIVE</b> —luxury residence halls with
              skyline views, rooftop pool, study lounges, dining. Walkable
              Midtown. Steps to Piedmont Park, the Atlanta BeltLine, galleries,
              and design districts — study by day, discover the city by night.
            </div>

            <div
              class="lifeCommunity-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? lifeCommunityCnBanners
                    : lifeCommunityEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="10" class="vertical-center">
              <div class="content-title">Recognition</div>
              <div class="text">
                <ul>
                  <li>Best Big City for Film Production (MovieMaker)</li>
                  <li>Best City to Start a Career (WalletHub)</li>
                  <li>Most Livable Cities (The Economist)</li>
                  <li>Best City to Start a Business (LinkedIn)</li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="14">
              <img
                class="w100"
                src="@/assets/images/newlocations/atlanta/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">International support</div>
              <div class="text">
                <div class="support-title">
                  How does SCAD support international students?
                </div>
                <div class="support-text">
                  SCAD welcomes students from 100+ countries with full support
                  in visas, onboarding, housing, and academics.
                  <br />
                  Through the
                  <a
                    href="https://www.scad.edu/life/international-student-life/international-student-resources"
                    target="_blank"
                    >SCAD International Student Services Office (ISSO)</a
                  >, students receive personalized guidance before arrival,
                  during study, and after graduation — including cultural
                  events, advising, and career mentorship.
                </div>
                <div class="line"></div>

                <div class="support-title">
                  Can parents join info sessions remotely?
                </div>
                <div class="support-text">
                  Yes. Parents and guardians are welcome to join our virtual
                  info sessions or book a 1:1 Chinese-language consultation with
                  SCAD admission advisers. Sessions include introductions,
                  career outcomes, and application guidance.
                </div>
                <div class="line"></div>
                <div class="support-title">
                  What are the application timelines?
                </div>
                <div class="support-text">
                  New students may begin in fall (September), winter (January),
                  spring (March), or summer (June). <br />
                  Admission is selective — applying early ensures full
                  consideration for programs and scholarships.
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">Start your SCAD journey</div>
              <div class="text">
                Click the 'Chat with Admission' to request program information
                or book a 1:1 consultation with a SCAD admission adviser. Our
                team responds in 2 business days with your Chinese info pack
                (program list + timeline).
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center2">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div v-if="$i18n.locale === 'zh'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <div class="content-title">为什么选择亚特兰大</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>创意之都，近在咫尺</b
                    >。在美国发展最迅猛的影视、奢侈品、科技与设计中心之一求学——校园与行业，比邻而居。
                  </li>

                  <li>
                    <b>精准定位，品牌共鸣</b>。从 LED 影棚创作到
                    <a href="https://www.scadfash.org/" target="_blank"
                      >SCAD FASH</a
                    >
                    时尚艺术博物馆的品牌合作，你的课程项目将紧密融入亚特兰大的影视制作、时尚设计与媒体生态体系。
                  </li>
                  <li>
                    <b>都市人脉，触手可及</b
                    >。周边的大型公司与工作室，将你的项目转化为实习——再将实习，延伸为就业。
                  </li>
                </ul>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >探索校园设施与学位课程</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/atlanta/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="building-box">
            <div
              class="building-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? buildingCnBanners
                    : buildingEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">职业方向</div>
              <div class="text" style="margin-top: 30px">
                通过
                <a
                  target="_blank"
                  href="https://www.scad.edu/about/industry-partnerships/scadpro"
                  >SCADpro</a
                >，学生为谷歌、宝马BMW、耐克、德勤等企业解决真实课题，累积作品与人脉。
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >动画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >插画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >交互设计与游戏开发</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >服装设计</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >视觉特效</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <div
                class="career-banner-swiper-container swiper-container location-banner"
              >
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(banner, index) in careerCnBanners"
                    :key="index"
                  >
                    <div class="slide-inner">
                      <img :src="banner.src" alt="" />
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination"></div>
                <img
                  class="button-prev"
                  src="@/assets/images/newlocations/img_01.png"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 30px;
                    z-index: 999999;
                  "
                />

                <img
                  class="button-next"
                  src="@/assets/images/newlocations/img_02.png"
                  style="
                    position: absolute;
                    top: 50%;
                    right: 30px;
                    z-index: 999999;
                  "
                />
              </div>
            </el-col>
          </el-row>

          <el-row class="climate-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/atlanta/07climate/01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="12" class="climate-content">
              <div class="content-title">气候与交通</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>季节气候</b
                    >：与上海、杭州相似，属于亚热带湿润气候，四季分明，冬季短且温和，春季宜人。
                  </li>

                  <li>
                    <b>全球航点</b
                    >：亚特兰大国际机场（ATL）是全球客运量最大的航空枢纽，直飞与中转均十分便捷。
                  </li>
                  <li>
                    <b>城市通勤</b
                    >：从校园出发，可轻松抵达各大工作室、品牌总部与创意场馆。
                  </li>
                </ul>

                <div class="tips2">
                  <b>温馨提示</b>：
                  无法亲临校园？预约一场10分钟的虚拟导览，或与SCAD招生顾问一对一交流。
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">学习与生活</div>
            <div class="text">
              在现代、安全、便利的环境中开启创意旅程。<br />
              入住 FORTY、FORTY FOUR、FORTY FIVE
              公寓式宿舍，俯瞰城市天际线，屋顶泳池、学习休息室与餐饮空间让生活更惬意。走出校园，步行可达皮德蒙特公园与环线绿道，街角的画廊与设计商店，让每一次出行都充满灵感。
            </div>

            <div
              class="lifeCommunity-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? lifeCommunityCnBanners
                    : lifeCommunityEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="10" class="vertical-center">
              <div class="content-title">城市与院校荣誉</div>
              <div class="text">
                <ul>
                  <li>最佳电影制作大都市——《电影制作人》<i>(MovieMaker)</i></li>
                  <li>最佳职业起步城市——<i>WalletHub</i></li>
                  <li>最宜居城市——《经济学人》</li>
                  <li>最佳创业城市——领英</li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="14">
              <img
                class="w100"
                src="@/assets/images/newlocations/atlanta/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">国际学生支持</div>
              <div class="text">
                <div class="support-title">SCAD 如何支持国际学生？</div>
                <div class="support-text">
                  SCAD 欢迎来自 100
                  多个国家的学生，提供签证、入学、住宿与学业全方位支持。<br />
                  并通过
                  <a
                    target="_blank"
                    href="https://www.scad.edu/life/international-student-life/international-student-resources"
                    >SCAD 国际学生服务办公室（ISSO）</a
                  >
                  提供从入学前到毕业后的专属指导、跨文化活动与职业辅导，助力学生在全球职场取得成功。
                </div>
                <div class="line"></div>

                <div class="support-title">家长能否远程参加资讯会？</div>
                <div class="support-text">
                  可以。家长可参加线上中文资讯会，或预约一对一招生官咨询，了解课程介绍、就业成果与申请流程。
                </div>
                <div class="line"></div>
                <div class="support-title">申请时间线是怎样的？</div>
                <div class="support-text">
                  新生可于 秋季（9 月）、冬季（1 月）、春季（3 月） 或 夏季（6
                  月） 入学。<br />
                  SCAD
                  采取择优录取，建议尽早申请，以获得课程与奖学金的充分评估机会。
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">开启你的 SCAD 之旅</div>
              <div class="text">
                填写表单即可获取课程资料，或预约与 SCAD 招生官一对一交流。<br />
                招生团队将在 2
                个工作日内回复，并发送中文资料包（含学位课程清单与申请时间线）。
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center2">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";

export default {
  data: function () {
    return {
      selectedMenu: "atlanta",
      buildingCnBanners: [
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/cn/swiper_08.jpg"),
          url: "",
        },
      ],
      buildingEnBanners: [
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/05building/en/swiper_08.jpg"),
          url: "",
        },
      ],

      careerCnBanners: [
        {
          src: require("@/assets/images/newlocations/atlanta/06career/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/06career/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/06career/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/06career/04.jpg"),
          url: "",
        },
      ],
      lifeCommunityCnBanners: [
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/cn/08.jpg"),
          url: "",
        },
      ],
      lifeCommunityEnBanners: [
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/atlanta/08life_community/en/08.jpg"),
          url: "",
        },
      ],
    };
  },
  mounted() {
    // this.selectedMenu = this.$route.params["name"];
    // var query = this.$route.query;
    // if (query.l) {
    //   this.selectedMenu = query.l;
    // }

    this.selectedMenu = this.$route.fullPath.substring(
      this.$route.fullPath.lastIndexOf("/") + 1
    );

    this.mySwiper = this.initSwiper(".building-banner-swiper-container");
    this.careerSwiper = this.initSwiper(".career-banner-swiper-container");
    this.careerSwiper = this.initSwiper(
      ".lifeCommunity-banner-swiper-container"
    );
  },
  methods: {
    locationMenuItemClick(menu) {
      // this.selectedMenu = menu;
      // this.goTop();
      window.location.href = menu;
    },
    initSwiper: function (clazz) {
      var swiperOptions = {
        loop: true,
        speed: 1000,
        autoplay: true,
        grabCursor: true,
        autoHeight: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        observer: true,

        pagination: {
          el: clazz + " .swiper-pagination",
        },
        navigation: {
          nextEl: clazz + " .button-next",
          prevEl: clazz + " .button-prev",
        },
        on: {},
      };

      return new Swiper(clazz, swiperOptions);
    },
  },
};
</script>

<style scoped lang="less">
@import "../../locations.less";
</style>
